import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { ContactsListResponse } from "@manageContacts/store/models";

export const fetchContactsThunk = createAsyncThunk<ContactsListResponse, number | undefined, ThunkApiConfig>(
  "manageContacts/fetchContacts",
  async (entitledUserId, { extra, rejectWithValue }) => {
    try {
      const url = `contacts/v1/user/ManageContacts`;

      const response = await extra<ContactsListResponse>(url, {
        method: "GET",
        queryParams: entitledUserId ? { entitledUserId } : undefined,
      });

      return response.data;
    } catch (error) {
      console.error("[Manage Contacts API] Error fetching data:", error);

      return rejectWithValue("Failed to fetch IFC data");
    }
  }
);
